import { EventTypes, track } from '@mc/track-event'
import {
  ActionTypes,
  KeyTypes,
  saveUserData,
  getTrackedId,
} from '@mc/user-data'

export const trackLessonPageViewed = ({
  slug,
  courseId,
  chapter,
  categoryId,
  subcategoryId = null,
}) => {
  const catId = getTrackedId({ key: KeyTypes.CATEGORY, id: categoryId })
  const subcatId = subcategoryId
    ? getTrackedId({
        key: KeyTypes.SUBCATEGORY,
        id: subcategoryId,
      })
    : ''
  const chapterId = getTrackedId({ key: KeyTypes.LESSON, id: chapter.id })
  const parsedCourseId = getTrackedId({ key: KeyTypes.CLASS, id: courseId })

  const eventName = EventTypes.LOGGED_OUT_LESSON_PAGE_VIEWED

  track(eventName, {
    course: slug,
    chapter: {
      title: chapter.title,
      number: chapter.number,
      id: chapter.id,
    },
    platform: 'next',
    stored_category_id: catId,
    stored_subcategory_id: subcatId,
    stored_course_id: parsedCourseId,
    stored_lesson_id: chapterId,
  })

  saveUserData({
    key: KeyTypes.CATEGORY,
    id: catId,
    actionType: ActionTypes.BROWSING,
    eventName,
  })

  saveUserData({
    key: KeyTypes.SUBCATEGORY,
    id: subcatId,
    actionType: ActionTypes.BROWSING,
    eventName,
  })

  saveUserData({
    key: KeyTypes.CLASS,
    id: parsedCourseId,
    actionType: ActionTypes.BROWSING,
    eventName,
  })

  saveUserData({
    key: KeyTypes.LESSON,
    id: chapterId,
    actionType: ActionTypes.BROWSING,
    eventName,
  })
}
